export var red = {
    900: '#B71C1C',
    800: '#C62828',
    700: '#D32F2F',
    600: '#E53935',
    500: '#F44336',
    400: '#EF5350',
    300: '#E57373',
    200: '#EF9A9A',
    100: '#FFE3E4',
    50: '#FFF5F7',
};
//# sourceMappingURL=red.js.map